
import React from 'react';

/**
 * Simple navigation helper that works both with the custom
 * `window.REACT_APP_NAVIGATE` function (if it exists) and with a
 * standard browser navigation fallback.
 */
const navigate = (path: string) => {
  if (typeof window !== 'undefined' && typeof (window as any).REACT_APP_NAVIGATE === 'function') {
    (window as any).REACT_APP_NAVIGATE(path);
  } else {
    // Fallback – change location directly
    window.location.href = path;
  }
};

export default function Footer() {
  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-palette-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                Nox Sanat
              </h3>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Sanatın büyüleyici dünyasına hoş geldiniz. Özgün yağlı boya ve sulu boya
              eserlerle evinizi güzelleştirin, sanatın gücünü hissedin.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg text-gray-300"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg text-gray-300"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-twitter-fill text-lg text-gray-300"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-line text-lg text-gray-300"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Ana Sayfa
                </a>
              </li>
              <li>
                <a
                  href="#featured-artworks-section"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Koleksiyon
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Müşteri Hizmetleri</h4>
            <ul className="space-y-3">
              <li>
                <a
                  onClick={() => {
                    navigate('/order-tracking');
                    setTimeout(() => {
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }, 100);
                  }}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Sipariş Takibi
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Kargo Bilgileri
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate('/return-policy');
                    // Sayfa yüklendikten sonra en üste kaydır
                    setTimeout(() => {
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }, 100);
                  }}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  İade Koşulları
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate('/secure-shopping');
                    // Sayfa yüklendikten sonra en üste kaydır
                    setTimeout(() => {
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }, 100);
                  }}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Güvenli Alışveriş
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate('/privacy-policy');
                    // Sayfa yüklendikten sonra en üste kaydır
                    setTimeout(() => {
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }, 100);
                  }}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Gizlilik Politikası
                </a>
              </li>
              <li>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/terms-of-service')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Kullanım Şartları
                </button>
              </li>
            </ul>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">
              © 2024 Nox Sanat. Tüm hakları saklıdır.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gray-400 text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
